import React, { createContext, useContext } from 'react'
import { RealEstateData } from 'types'

type GlobalDataContextValue = RealEstateData | null

const GlobalDataContext = createContext<GlobalDataContextValue>(null)

type GlobalDataProviderProps = {
  global_data: RealEstateData
  children: React.ReactNode
}

export const GlobalDataProvider = ({ global_data, children }: GlobalDataProviderProps) => (
  <GlobalDataContext.Provider value={global_data}>{children}</GlobalDataContext.Provider>
)

export const useGlobalData = () => useContext(GlobalDataContext)
